import { render, staticRenderFns } from "./addPeople.vue?vue&type=template&id=0b6638df&scoped=true&"
import script from "./addPeople.vue?vue&type=script&lang=js&"
export * from "./addPeople.vue?vue&type=script&lang=js&"
import style0 from "./addPeople.vue?vue&type=style&index=0&id=0b6638df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6638df",
  null
  
)

export default component.exports